<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <EditDocument title="รายการเอกสาร"></EditDocument>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditDocument from "./EditDocument";
export default {
  name: "documentDetail",
  components: {
    EditDocument,
  },
};
</script>
<style scoped></style>
